import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';

import { formattedkW, formattedDollar, formattedNumber } from '../../../../../utils/formatterHelpers';
import '../../../../../grid.css';
import './cashpoints.css';
import { Container } from './styles';

class CashPoints extends React.Component {
    static propTypes = {
        annualResults: PropTypes.object.isRequired,
        setSelectedFinancing: PropTypes.func.isRequired,
        includeESS: PropTypes.bool.isRequired,
        essPrice: PropTypes.number.isRequired,
        cashprice: PropTypes.number.isRequired,
        systemSize: PropTypes.number.isRequired,
        projectState: PropTypes.number.isRequired,
        annualInflation: PropTypes.number.isRequired,
        taxRate: PropTypes.number.isRequired,
        mosaicFee: PropTypes.number.isRequired,
        loanProvider: PropTypes.string.isRequired,
        showLoan: PropTypes.bool.isRequired,
        resiToggle: PropTypes.bool.isRequired,
    };

    handleSelectPPA() {
        const { setSelectedFinancing } = this.props;
        setSelectedFinancing(1);
    }

    handleSelectLoan() {
        const { setSelectedFinancing } = this.props;
        setSelectedFinancing(2);
    }

    handleSelectOBS() {
        const { setSelectedFinancing } = this.props;
        setSelectedFinancing(3);
    }

    handleSelectCash() {
        const { setSelectedFinancing } = this.props;
        setSelectedFinancing(4);
    }

    handleSelectCAP() {
        const { setSelectedFinancing } = this.props;
        setSelectedFinancing(5);
    }


    render() {
        const {
            annualResults,
            annualInflation,
            includeESS,
            essPrice,
            cashprice,
            systemSize,
            taxRate,
            resiToggle,
            projectState,
            mosaicFee,
            loanProvider,
            showLoan,
        } = this.props;

        let cashDiscount = 0;
        if (includeESS && loanProvider === 'mosaic' && resiToggle) {
            cashDiscount = cashprice + essPrice * (1 - mosaicFee);
        }
        if (loanProvider === 'mosaic' && resiToggle) {
            cashDiscount = cashprice * (1 - mosaicFee);
        }


        const formattedPrice = formattedDollar(cashprice);
        const kW = formattedkW(systemSize / 1000);
        const firstYearBenefits = annualResults[1].cumulativeCashSavings + cashprice;


        const incentivePercent = (annualResults[30]
            .cumulativeIncentives +
            annualResults[1].cashITC + annualResults[1].macrs) / cashprice * 100;

        let incentive = '';
        if (projectState === 1) {
            incentive = 'SGIP';
        }
        if (projectState === 2) {
            incentive = 'SMART';
        }
        if (projectState === 3) {
            incentive = 'RECs';
        }
        if (projectState === 4) {
            incentive = 'NY Incentives';
        }

        let commercial = 'and ITC';
        if (!resiToggle) {
            commercial = ', ITC, and MACRS';
        }
        return (
            <Container>
                <div className="row">
                    <p>{incentive} {commercial} pay for &nbsp;
                        {formattedNumber(incentivePercent)}%
                        of the installed price!
                    </p>
                </div>
                <Paper className="row cashPoints">
                    <h1>Cash Purchase Stats</h1>
                    <div className="col span-1-of-3 ">
                        <ul className="align">
                        <li>
                            Total Incentives:
                            ${formattedNumber(annualResults[30].cumulativeTotalAnnualIncentives)}
                        </li>
                        <li>Cash Price: ${formattedPrice}</li>
                        {showLoan && loanProvider === 'mosaic' ?
                                <li>
                                    Cash Discount:
                                    ${formattedDollar(-cashDiscount)}
                                </li>
                                : null }
                            <li>
                                Year 1 Benefit:
                                ${formattedNumber(firstYearBenefits)}
                            </li>
                            <li>
                                Price net Yr. 1 Benefits:
                                ${formattedNumber(-annualResults[1].cumulativeCashSavings)}
                            </li>
                        </ul>
                    </div>
                    <div className="col span-1-of-3">
                        <ul className="align">
                            <li>
                                Avoided Utility Cost:
                                ${formattedNumber(annualResults[30].cumulativeSolarSavings)}
                            </li>

                            <li>
                                Total savings:
                                ${formattedNumber(annualResults[30].cumulativeCashSavings)}
                            </li>
                        </ul>
                    </div>
                    <div className="col span-1-of-3">
                        <ul className="align">
                            <li> System Size: {kW} kW</li>
                            <li>
                                Lifetime kWh:&nbsp;
                                {formattedNumber(annualResults[30].cumulativeSystemProduction)} kWh
                            </li>
                            <li>Utility Inflation: {annualInflation} %</li>
                            {resiToggle ? null : <li>Tax Rate: {taxRate} %</li>}
                        </ul>
                    </div>
                </Paper>
            </Container>
        );
    }
}

export default CashPoints;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/CashPoints/CashPoints.js